import { Spin } from "antd";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
      }}
    >
      <Spin size="small" />
    </div>
  );
};

export default Loader;
